import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-admin-login',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './admin-login.html',
  styleUrls: ['./admin-login.scss']
})
export class AdminLoginComponent implements OnInit {
  loginData = {
    email: '',
    password: ''
  };
  
  isLoading = false;
  showPassword = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    // Check if user is already logged in and is admin
    this.authService.currentUser$.subscribe(user => {
      if (user && (user.role === 'admin' || user.role === 'super_admin')) {
        this.router.navigate(['/admin/dashboard']);
      }
    });
  }

  async onLogin() {
    if (!this.loginData.email || !this.loginData.password) {
      this.toastService.error('Please fill in all fields');
      return;
    }

    this.isLoading = true;

    try {
      const result = await this.authService.loginWithEmail(this.loginData).toPromise();
      if (result?.success && result.user) {
        if (result.user.role === 'admin' || result.user.role === 'super_admin') {
          this.toastService.success('Welcome back, Admin!');
          this.router.navigate(['/admin/dashboard']);
        } else {
          this.toastService.error('Access denied. Admin privileges required.');
          await this.authService.logout().toPromise();
        }
      } else {
        this.toastService.error(result?.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      this.toastService.error('Login failed. Please try again.');
    } finally {
      this.isLoading = false;
    }
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  goToUserLogin() {
    this.router.navigate(['/login']);
  }
} 